import React from "react";
import BankFeedsCommonLayout from "../../components/bankFeeds/layout";

const IntuitBankFeedsError: React.FC = () => {
  return (
    <BankFeedsCommonLayout>
      <div className="mt-4 text-lg">
        There was a temporary issue connecting to your financial institution.
        Please restart the linking process.
      </div>
    </BankFeedsCommonLayout>
  );
};

export default IntuitBankFeedsError;
